import { render, staticRenderFns } from "./RoundQuestionModal.vue?vue&type=template&id=6acc7a24&"
import script from "./RoundQuestionModal.vue?vue&type=script&lang=js&"
export * from "./RoundQuestionModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports